export default __webpack_public_path__ + "static/media/reverseswing.7d30a0aa.png";